
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Declare global gtag function
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Initialize dataLayer if it doesn't exist
window.dataLayer = window.dataLayer || [];
// Define gtag function if it doesn't exist
window.gtag = function(){window.dataLayer.push(arguments);}

// Call gtag function with 'js' and new Date()
window.gtag('js', new Date());

createRoot(document.getElementById("root")!).render(<App />);
